// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-card[data-v-093d1025]{box-shadow:.869231px 3.47692px 37.3769px -7.82308px rgba(80,67,199,.2)!important;border-radius:30px!important;border:unset!important;cursor:pointer}.provider-card[data-v-093d1025]:hover{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)!important}", ""]);
// Exports
module.exports = exports;
